import { supabase } from '@/shared/lib/supabase';
import type { IEngajamentoRepository } from '../domain/ports/IEngajamentoRepository';
import type { ContadoresEngajamentoDia, RankingJukeboxDiaItem } from '../domain/entities/Engajamento';

export const engajamentoRepository: IEngajamentoRepository = {

  async buscarContadoresDia(telaId: string): Promise<ContadoresEngajamentoDia> {
    const { data, error } = await supabase.rpc(
      'contadores_engajamento_dia' as never,
      { p_tela_id: telaId } as never,
    );
    if (error) throw error;
    const row = (data as ContadoresEngajamentoDia[] | null)?.[0];
    return { pedidos: row?.pedidos ?? 0, votos: row?.votos ?? 0 };
  },

  async buscarRankingDia(telaId: string): Promise<RankingJukeboxDiaItem[]> {
    const { data, error } = await supabase.rpc(
      'ranking_jukebox_dia' as never,
      { p_tela_id: telaId } as never,
    );
    if (error) throw error;
    return (data ?? []) as RankingJukeboxDiaItem[];
  },
};
